export default __webpack_public_path__ + "static/media/no-records.edaf7f39.webp";